import React from 'react';
import { valuesBand } from '../data/content';
import { SectionHeading } from './SectionHeading';

/** Belt colors for the 10 values (decorative only: every school uses its own belt order) */
const belts = ['#FFFFFF', '#FFD60A', '#FF8C1A', '#21A366', '#1E88E5', '#7B4FD6', '#E63946', '#8B5A2B', '#3A3F4B', '#0B0C0F'];

/** New in this landing: one value per class (as a belt strip) + the 3 age levels every class adapts to */
export function ValuesBand() {
  return <section aria-labelledby="values-title" className="bg-ink py-12 md:py-16" data-id="element-251" data-mp="146zc2bw0927d">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-252" data-mp="193y50r3xn33z">
        <SectionHeading id="values-title" tone="dark" eyebrow={valuesBand.eyebrow} title={valuesBand.title} sub={valuesBand.sub} data-id="element-253" data-mp="1e2j6etux7su0" />

        <ol className="mx-auto mt-8 grid max-w-[980px] grid-cols-2 gap-2.5 sm:grid-cols-3 md:mt-10 md:grid-cols-5 md:gap-3" data-id="element-254" data-mp="1j36y7hqz4dpa">
          {valuesBand.values.map((v, i) => <li key={v.n} className="overflow-hidden rounded-xl bg-white/[0.06] ring-1 ring-white/10" data-id="element-255" data-mp="2ufzosp812w3r" data-mpi={i}>
              <span aria-hidden="true" className="block h-3 w-full" style={{
            background: belts[i % belts.length],
            boxShadow: 'inset 0 -1px 0 rgba(0,0,0,0.25)'
          }} data-id="element-256" data-mp="15zvrkodkdmw6" />
              <div className="px-3.5 py-3" data-id="element-257" data-mp="x00g0ig3jpvm">
                <p className="font-display text-[11px] font-extrabold tracking-[0.12em] text-sun" data-id="element-258" data-mp="wypb2fax0c2x">CLASS {v.n}</p>
                <p className="mt-0.5 font-display text-[17px] font-black uppercase leading-tight tracking-tight text-white" data-id="element-259" data-mp="s0w7zv4wry6v">{v.value}</p>
              </div>
            </li>)}
        </ol>

        <h3 className="mt-10 text-center font-display text-[13px] font-black tracking-[0.14em] text-sun" data-id="element-260" data-mp="ia1imhwd8ih7">{valuesBand.agesTitle}</h3>
        <ul className="mx-auto mt-4 grid max-w-[980px] gap-3 md:grid-cols-3" data-id="element-261" data-mp="9ao9xrg2fxxj">
          {valuesBand.ages.map(a => <li key={a.age} className="rounded-xl border border-white/10 bg-brand p-5" data-id="element-262" data-mp="4c4jbdqj1xyu">
              <p className="inline-block rounded-md bg-coral px-2 py-1 font-display text-[12px] font-black tracking-[0.1em] text-white" data-id="element-263" data-mp="3vi61s7ctntui">{a.age}</p>
              <p className="mt-3 text-[15px] leading-relaxed text-white/85" data-id="element-264" data-mp="3lspbvhpnkcdr">{a.text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}